import { Component } from '@verndale/core';

class CircleGraph extends Component {
  preferReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
    .matches;

  constructor(el: HTMLElement) {
    super(el);

    this.init();
  }

  setupDefaults() {
    this.dom = {
      svg: this.el.querySelector('.circle-graph__box svg') as HTMLElement
    };
  }

  init() {
    const pieChartObserver = new IntersectionObserver(
      entries => {
        entries.forEach(chart => {
          console.log('chart', chart);
          if (chart.isIntersecting) {
            let speed = Number(this.el.dataset.speed) || 0;
            this.preferReducedMotion && (speed = 0);
            const delay = Number(this.el.dataset.delay) || 0;
            const percent = Number(this.el.dataset.percent) || 0;

            const circle = chart.target.querySelector('circle');

            chart.target.setAttribute(
              'aria-label',
              `${percent} percent pie chart`
            );

            if (circle) {
              circle.animate(
                [
                  {
                    strokeDashoffset: 100
                  },
                  {
                    strokeDashoffset: 100 - percent
                  }
                ],
                {
                  duration: speed,
                  easing: 'cubic-bezier(0.57,-0.04, 0.41, 1.13)',
                  fill: 'forwards'
                }
              );
            }

            const text = chart.target.querySelector('text');
            if (text) {
              text.textContent = `${percent}%`;

              text.animate(
                [
                  {
                    opacity: 0,
                    transform: 'translateY(20%)'
                  },
                  {
                    opacity: 1,
                    transform: 'translateY(0%)'
                  }
                ],
                {
                  delay: this.preferReducedMotion ? 0 : delay,
                  duration: this.preferReducedMotion ? 0 : 300,
                  easing: 'cubic-bezier(0.57,-0.04, 0.41, 1.13)',
                  fill: 'forwards'
                }
              );
            }
            pieChartObserver.unobserve(chart.target);
          }
        });
      },
      {
        threshold: 0
      }
    );

    if (this.dom.svg) {
      pieChartObserver.observe(this.dom.svg as HTMLElement);
    }
  }
}

export default CircleGraph;
